import { API_URL, apiFetch } from "../services.props";
import {
  AdminSupportResponseProps,
  AdminSupportRespondResponseProps,
  CreateIncidentPayload,
  RespondIncidentPayload,
  SupportCreateResponseProps,
  SupportResponseProps,
} from "./support.props";

const parseErrorMessage = async (res: Response): Promise<string> => {
  try {
    const body = await res.json();
    if (typeof body?.error === "string" && body.error.length) {
      return body.error;
    }
  } catch {
    // el cuerpo de la respuesta no era JSON
  }
  return "errorFetchingData";
};

export const SupportServices = () => {
  const getIncidents = async (): Promise<SupportResponseProps> => {
    const res = await apiFetch(API_URL.SUPPORT());

    if (!res.ok) {
      return { error: true, messageError: await parseErrorMessage(res), data: null };
    }

    return { error: false, messageError: "", data: await res.json() };
  };

  const createIncident = async (
    payload: CreateIncidentPayload
  ): Promise<SupportCreateResponseProps> => {
    const res = await apiFetch(API_URL.SUPPORT(), {
      method: "POST",
      body: JSON.stringify(payload),
    });

    if (!res.ok) {
      return { error: true, messageError: await parseErrorMessage(res), data: null };
    }

    return { error: false, messageError: "", data: await res.json() };
  };

  const getAllIncidents = async (): Promise<AdminSupportResponseProps> => {
    const res = await apiFetch(API_URL.ADMIN_SUPPORT());

    if (!res.ok) {
      return { error: true, messageError: await parseErrorMessage(res), data: null };
    }

    return { error: false, messageError: "", data: await res.json() };
  };

  const respondIncident = async (
    id: number,
    payload: RespondIncidentPayload
  ): Promise<AdminSupportRespondResponseProps> => {
    const res = await apiFetch(API_URL.ADMIN_SUPPORT(`/${id}/responses`), {
      method: "POST",
      body: JSON.stringify(payload),
    });

    if (!res.ok) {
      return { error: true, messageError: await parseErrorMessage(res), data: null };
    }

    return { error: false, messageError: "", data: await res.json() };
  };

  // El solicitante contesta en su ticket (si no está completado).
  const replyIncident = async (
    id: number,
    message: string
  ): Promise<SupportCreateResponseProps> => {
    const res = await apiFetch(API_URL.SUPPORT(`/${id}/responses`), {
      method: "POST",
      body: JSON.stringify({ message }),
    });

    if (!res.ok) {
      return { error: true, messageError: await parseErrorMessage(res), data: null };
    }

    return { error: false, messageError: "", data: await res.json() };
  };

  // Marca el ticket como leído por quien lo abre (solicitante o administrador).
  const markIncidentRead = async (
    id: number,
    asAdmin: boolean
  ): Promise<AdminSupportRespondResponseProps> => {
    const endpoint = asAdmin
      ? API_URL.ADMIN_SUPPORT(`/${id}/read`)
      : API_URL.SUPPORT(`/${id}/read`);
    const res = await apiFetch(endpoint, { method: "POST" });

    if (!res.ok) {
      return { error: true, messageError: await parseErrorMessage(res), data: null };
    }

    return { error: false, messageError: "", data: await res.json() };
  };

  return {
    getIncidents,
    createIncident,
    getAllIncidents,
    respondIncident,
    replyIncident,
    markIncidentRead,
  };
};
